import React from "react";

const PermissionTable = ({ pages, perms, onCheckboxChange, allChecked, onCheckAll }) => {

  const RenderPages = (pagesList, level = 0) => {
    return pagesList.map((page) => <React.Fragment key={page.page_id}>
      <div className="d-flex justify-content-between align-items-center" style={{ paddingLeft: level * 20, borderBottom: "1px solid #c1c1c1" }}>
        <p className="mb-0 py-2" style={{ fontSize: 16, fontWeight: level ? 400 : 500, marginRight: 4 }}>{level === 0 ? '●' : level === 1 ? '○' : '–'} {page.page_name}</p>             
        <div style={{ minWidth: 60, textAlign: 'right' }}> 
          <input type="checkbox" checked={!!perms[page.page_id]} onChange={e => onCheckboxChange(page, e.target.checked)} />
        </div>
      </div>
      {page.children && page.children.length > 0 && RenderPages(page.children, level + 1)}
    </React.Fragment>)
  }

  return <div className="my-2">
      <div className="d-flex justify-content-between align-items-center">
        <p className="my-0 py-2" style={{ textAlign: 'left', fontSize: 16, fontWeight: 500 }}>PAGES</p>             
        <div style={{ minWidth: 60, textAlign: 'right' }}>Check 
          <input type="checkbox" checked={allChecked} onChange={onCheckAll} style={{ marginLeft: 4 }} />
        </div>
      </div>
      <div>{RenderPages(pages)}</div>
  </div>
}

export default PermissionTable;